import { createSlice } from "@reduxjs/toolkit";
import {     contractNote_listThunk } from "./thunk";


export const initialState = {
  contractNote_listData: [],
  contractNote_listError: {
    code: null,
    message: '',
    data: null
  },
  contractNote_listLoading: false,
  
  
};

const ContractNote_List = createSlice({
  name: "ContractNote_List",
  initialState, 
  reducers: {}, 
  extraReducers: (builder) => {

    builder.addCase(contractNote_listThunk.pending, (state) => {
      state.contractNote_listLoading = true ;
      state.contractNote_listError = initialState.contractNote_listError; 
  });
    builder.addCase(contractNote_listThunk.fulfilled, (state, action) => {
        state.contractNote_listData = action.payload.data;
        state.contractNote_listLoading = false ;
    });
    builder.addCase(contractNote_listThunk.rejected, (state, action) => {
      state.contractNote_listError = {
        code: action.payload?.code || null,
        message: action.payload?.message || "An unknown error occurred",
        data: action.payload?.data || null
      };
        state.contractNote_listLoading = false ;
    });
}
});

export const {
  apiRequest,
  apiError,
  
  
} = ContractNote_List.actions

export default ContractNote_List.reducer;